import { type LoginResponse, logout } from '../api/auth'
import { Button, Callout } from '../components/ui'
import { EnrollmentCard } from './AccountSecurityPage'

/**
 * R2-MFA (D-18b). Il codice di accesso e' obbligatorio per tutti: chi non lo ha ancora configurato
 * entra con una sessione ristretta (il server blocca ogni altra API con MFA_SETUP_REQUIRED) e vede
 * solo questa pagina, fuori dalla shell, finche' non completa QR + codici di recupero.
 */
export function MfaSetupGatePage({ auth, onDone, onLogout }: {
  auth: LoginResponse
  onDone: () => void
  onLogout: () => void
}) {
  async function handleLogout() {
    try { await logout() } catch { /* sessione gia' scaduta: si esce comunque */ }
    onLogout()
  }

  return (
    <main className="d-flex justify-content-center md-u-surface-low" style={{ minHeight: '100svh', padding: 16 }}>
      <div className="d-flex flex-column gap-3" style={{ width: '100%', maxWidth: 520 }}>
        <h1 className="md-typescale-headline-small mt-4 mb-0">Configura il codice di accesso</h1>
        <Callout tone="warning" icon="gpp_maybe">
          Ciao {auth.name}: per usare il CRM serve il codice di accesso a due fattori. Collega
          un'app di autenticazione e conserva i codici di recupero: senza questo passaggio non puoi proseguire.
        </Callout>
        <EnrollmentCard onActivated={onDone} />
        <div>
          <Button variant="text" onClick={() => { void handleLogout() }}>Esci</Button>
        </div>
      </div>
    </main>
  )
}
